const users = {
  importersList: {
    importersListTitle: "Importers List",
    importers: "Importers",
    importer: "Importer",
    categories: "Categories",
    active: "Active",
    inactive: "Inactive",
    tableHeader: {
      companyName: "Company name",
      country: "Country",
      businessType: "Business Type",
      category: "Category",
      status: "Status"
    },
    noImportersFound: "There is no Importers yet",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by Importer company name",
    filters: {
      categories: "Categories",
      countries: "Countries",
      business: "Business Type",
      status: "Status",
      searchPlaceholders: {
        countries: "Search by Importer Country",
        categories: "Search by Importer Category",
        business: "Search by Importer Business Type"
      }
    },
    importerStatusFilter: {
      active: "Active",
      inactive: "Inactive",
      blocked: "Blocked"
    }
  },
  importersDetails: {
    pageTitle: "Importer Details",
    blockBtn: "Block",
    unblockBtn: "Unblock",
    blocked: "Blocked",
    company: {
      companyInfo: "Company Info",
      country: "Country",
      businessType: "Business Type",
      categories: "Categories"
    },
    account: {
      accountInfo: "Account Info",
      accountName: "Account Name",
      emailAddress: "Email Address",
      mobileNumber: "Mobile Number"
    },
    pendingCategoryWarning:
      "The suggested categories are still pending",
    rejectedCategoryWarning:
      "The suggested categories are rejected, importer can edit their profile and select new categories",
    blockImporter: {
      content: "Block",
      confirmationContent:
        "Are you sure you want to block this importer’s account? This action will restrict the user’s access to the platform."
    },
    unblockImporter: {
      content: "Unblock",
      confirmationContent:
        "Are you sure you want to unblock this Importer ?"
    }
  },
  exportersList: {
    exportersListTitle: "Exporters List",
    exporters: "exporters",
    exporter: "exporter",
    categories: "Categories",
    category: "Category",
    product: "Product",
    products: "Products",
    tableHeader: {
      companyName: "Company Name",
      country: "Country",
      businessType: "Business Type",
      category: "Category",
      status: "Status",
      pricingPlan: "Pricing Plan"
    },
    noExportersFound: "There is no Exporters yet",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by exporter company name",
    filters: {
      categories: "Categories",
      countries: "Countries",
      business: "Business Type",
      status: "Status",
      pricingPlan: "Pricing Plan",
      searchPlaceholders: {
        categories: "Search by Exporter Category",
        countries: "Search by Exporter Country",
        business: "Search by Exporter Business Type"
      }
    },
    inactive: "Inactive",
    exporterStatusFilter: {
      registered: "Registered",
      verified: "Verified",
      pendingBusinessVerification: "Pending Business Verification",
      businessVerified: "Business Verified",
      subscribed: "Subscribed"
    }
  },
  exporterDetails: {
    pageTitle: "Exporter Details",
    tabs: {
      companyProfile: "Company Profile",
      accountInfo: "Account Info",
      verificationAndPricing: "Verification Info & Pricing"
    },
    mainInfo: {
      description: "Description",
      categories: "Categories",
      companyInfo: "Company Info",
      yearEstablished: "Year Established",
      yearsOfExperience: "Years of exporting experience",
      country: "Country",
      businessType: "Business Type"
    },
    contactDetails: {
      contactInfo: "Contact Info",
      exporterName: "Exporter Name",
      mobileNumber: "Mobile Number",
      emailAddress: "Email Address",
      website: "Website"
    },
    showcases: "Showcases",
    piece: "Piece",
    seeAllProducts: "See All Products",
    noShowcasesEmptyPlaceholder: "No Showcases available",
    inactive: "Inactive",
    subscriptionAndVerification: {
      subscription: {
        notSubscribed:
          "The exporter is not subscribed to any plan yet",
        subscriptionExpired:
          "The exporter's subscription plan has expired",
        pricingPlan: "Pricing Plan",
        plan: "Plan",
        year: "year",
        renewalData: "Renewal Date:"
      },
      verification: {
        notVerified: "The exporter is not Business verified",
        verificationMethod: "Verification Method",
        verifiedBy: "Verified by",
        method: "Method",
        offPlatform: "Off Platform",
        bankTransfer: "Bank Transfer",
        onlinePayment: "Online Payment"
      },
      transactions: {
        noTransactions: "No transactions yet",
        transactions: "Transactions",
        paymentReason: "Payment Reason",
        transactionId: "Transaction ID",
        transactionDate: "Transaction Date",
        amount: "Amount",
        status: "Status",
        succeeded: "Succeeded",
        failed: "Failed"
      },
      companyData: {
        companyDocuments: "Company Documents",
        uploadedDocuments: "Uploaded Documents",
        companyRepresentativeInfo: "Company Representative Info",
        representativeName: "Representative Name",
        emailAdress: "Email Address",
        mobileNumber: "Mobile Number",
        jobTitle: "Job Title",
        representativeId: "Representative ID"
      }
    },
    pendingCategoryWarning:
      "The suggested categories are still pending",
    rejectedCategoryWarning:
      "The suggested categories are rejected, exporter can edit their profile and select new categories"
  },
  combinedList: {
    combinedListTitle: "Combined Users List",
    combinedUser: "Combined user",
    combinedUsers: "Combined users",
    category: "Category",
    categories: "Categories",
    product: "Product",
    products: "Products",
    tableHeader: {
      companyName: "Company Name",
      country: "Country",
      businessType: "Business Type",
      category: "Category",
      status: "Status",
      pricingPlan: "Pricing Plan"
    },
    noCombinedFound: "There is no Combined users yet",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by company name",
    filters: {
      categories: "Categories",
      countries: "Countries",
      business: "Business Type",
      status: "Status",
      pricingPlan: "Pricing Plan",
      searchPlaceholders: {
        categories: "Search by Combined user Category",
        countries: "Search by Combined user Country",
        business: "Search by Combined user Business Type"
      }
    },
    inactive: "Inactive",
    combinedStatusFilter: {
      registered: "Registered",
      verified: "Verified",
      pendingBusinessVerification: "Pending Business Verification",
      businessVerified: "Business Verified",
      subscribed: "Subscribed",
      inactive: "Inactive"
    }
  },
  combinedDetails: {
    pageTitle: "Combined Details",
    tabs: {
      companyProfile: "Company Profile",
      accountInfo: "Account Info",
      verificationAndPricing: "Verification Info & Pricing"
    },
    mainInfo: {
      description: "Description",
      categories: "Categories",
      companyInfo: "Company Info",
      yearEstablished: "Year Established",
      yearsOfExperience: "Years of exporting experience",
      country: "Country",
      businessType: "Business Type"
    },
    contactDetails: {
      contactInfo: "Contact Info",
      combinedUserName: "Combined User Name",
      mobileNumber: "Mobile Number",
      emailAddress: "Email Address",
      website: "Website"
    },
    showcases: "Showcases",
    piece: "Piece",
    seeAllProducts: "See All Products",
    noShowcasesEmptyPlaceholder: "No Showcases available",
    inactive: "Inactive",
    subscriptionAndVerification: {
      subscription: {
        notSubscribed:
          "The combined user is not subscribed to any plan yet",
        subscriptionExpired:
          "The combined user's subscription plan has expired",
        pricingPlan: "Pricing Plan",
        plan: "Plan",
        year: "year",
        renewalData: "Renewal Date:"
      },
      verification: {
        notVerified: "The combined user is not Business verified",
        verificationMethod: "Verification Method",
        verifiedBy: "Verified by",
        method: "Method",
        offPlatform: "Off Platform",
        bankTransfer: "Bank Transfer",
        onlinePayment: "Online Payment"
      },
      transactions: {
        noTransactions: "No transactions yet",
        transactions: "Transactions",
        paymentReason: "Payment Reason",
        transactionId: "Transaction ID",
        transactionDate: "Transaction Date",
        amount: "Amount",
        status: "Status",
        succeeded: "Succeeded",
        failed: "Failed"
      },
      companyData: {
        companyDocuments: "Company Documents",
        uploadedDocuments: "Uploaded Documents",
        companyRepresentativeInfo: "Company Representative Info",
        representativeName: "Representative Name",
        emailAdress: "Email Address",
        mobileNumber: "Mobile Number",
        jobTitle: "Job Title",
        representativeId: "Representative ID"
      }
    },
    pendingCategoryWarning:
      "The suggested categories are still pending",
    rejectedCategoryWarning:
      "The suggested categories are rejected, exporter can edit their profile and select new categories"
  },
  businessFilter: {
    factory: "Factory",
    trade: "Trade",
    both: "Both"
  }
};

export default users;
